import * as React from "react";
import {
  Column,
  Columns,
  Divider,
  Radio,
  RadioGroup,
  Stack,
  Text,
  TextField,
} from "@origin-digital/ods-core";
import { styled } from "@mui/material";
import {
  Field,
  FieldMetaProps,
  FieldProps,
  FormikProps,
  useFormikContext,
} from "formik";
import { AccountPayer, FormValues } from "../types";
import ReadOnlyFieldWrapper from "../ReadOnlyFieldWrapper";
import { useAppContext } from "src/context/AppContext";

const StyledRadioGroup = styled(RadioGroup)({
  display: "flex",
  justifyContent: "flexStart",
  flexFlow: "row nowrap",
});

interface IEmailCommunicationsProps {
  id: string;
  name: string;
  homeUser: boolean;
}

const EmailCommunications = (props: IEmailCommunicationsProps) => {
  const { id, name, homeUser } = props;
  const { values } = useFormikContext<FormValues>();
  const {
    context: { user },
  } = useAppContext();
  const accountPayers = [
    values.electricityAccountPayer,
    values.gasLine?.accountPayer,
    values.gasMeter?.accountPayer,
    values.both?.accountPayer,
  ];
  const isReadOnly =
    homeUser &&
    values.accountHolder !== "company" &&
    !accountPayers.includes(AccountPayer.SOMEONE_ELSE);
  return (
    <Columns collapseBelow="md">
      <Column width="2/3">
        <Stack space="medium">
          {isReadOnly ? (
            <ReadOnlyFieldWrapper value={true}>
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Email
                  </Text>
                  <Text>{`${user?.email}`}</Text>
                </Stack>
                <Divider />
              </Stack>
            </ReadOnlyFieldWrapper>
          ) : (
            <Field name={name} id={id}>
              {({
                field,
                meta,
              }: {
                field: FormikProps<FieldProps>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={id}
                  variant="outlined"
                  label="Email"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
          )}
          <Field name="accountCommsPrefs" id="account-comms-prefs">
            {({ field }: { field: FormikProps<FieldProps> }) => (
              <StyledRadioGroup
                {...field}
                name="accountCommsPrefs"
                label="Send communications, including bills, by:"
              >
                <Radio id="post" label="Post" value="post" />
                <Radio id="email" label="Email" value="email" />
              </StyledRadioGroup>
            )}
          </Field>
        </Stack>
      </Column>
      <Column width="1/3" />
    </Columns>
  );
};

export default EmailCommunications;
